import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import AuthGuard from './components/auth/AuthGuard'
import Layout from './components/layout/Layout'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import UploadPage from './pages/UploadPage'
import TranscriptionPage from './pages/TranscriptionPage'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            {/* 公开路由 */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* 受保护的路由 */}
            <Route path="/dashboard" element={
              <AuthGuard>
                <DashboardPage />
              </AuthGuard>
            } />
            
            <Route path="/upload" element={
              <AuthGuard>
                <UploadPage />
              </AuthGuard>
            } />
            
            <Route path="/transcription/:id" element={
              <AuthGuard>
                <TranscriptionPage />
              </AuthGuard>
            } />
            
            {/* 默认路由重定向 */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* 404 页面 */}
            <Route path="*" element={
              <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                  <p className="text-gray-600 mb-4">页面不存在</p>
                  <a href="/dashboard" className="text-primary-600 hover:text-primary-500">
                    返回首页
                  </a>
                </div>
              </div>
            } />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  )
}

export default App